(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = callback => {
      var currTime = +new Date();
      var timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
      var id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = id => {
      clearTimeout(id);
    };
  }
}());

const animateScroll = (element, speed = 20, offset = 0) => {
  const rect = element.getBoundingClientRect();
  const top = window.pageYOffset + rect.top + offset;
  let currentTop = window.pageYOffset;
  let bScroll = rect.top > Math.abs(offset)
  let requestId;
  function step() {
    if (rect.top < 0) {
      if (speed >= currentTop - top) {
        speed = Math.ceil((currentTop - top) / 2)
      }
      currentTop = currentTop - speed;
      if (currentTop > top) {
        window.scrollTo(0, currentTop);
        requestId = window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(requestId);
      }
    } else {
      if (speed >= top - currentTop) {
        speed = Math.ceil((top - currentTop) / 2)
      }
      currentTop = currentTop + speed;
      if (bScroll && currentTop < top) {
        window.scrollTo(0, currentTop);
        requestId = window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(requestId);
      }
    }
  }
  window.requestAnimationFrame(step);
}
export default animateScroll